import React from 'react';
import { ClipboardList, Activity, Tag, FileText } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const ICONS = [ClipboardList, Activity, Tag, FileText];

export default function UseCasesSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#FAF7F2] border-b border-ct-line py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12 lg:mb-16">
          <p className="text-[11px] font-bold uppercase tracking-widest text-ct-brand mb-3">
            {t.usecases.subtitle}
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black text-ct-ink tracking-tight"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            {t.usecases.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {t.usecases.cases.map((c, i) => {
            const Icon = ICONS[i] || ClipboardList;
            return (
              <article
                key={i}
                className="ct-card-lift group relative bg-white border border-ct-line rounded-ct-card p-7 ct-shadow-sm"
                data-testid={`usecase-card-${i}`}
              >
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-12 h-12 bg-ct-brand-soft text-ct-brand flex items-center justify-center rounded-ct-chip">
                    <Icon className="w-5 h-5" strokeWidth={1.75} />
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-baseline justify-between gap-3 mb-2">
                      <h3
                        className="font-black text-ct-ink text-lg tracking-tight"
                        style={{ fontFamily: 'Chivo, sans-serif' }}
                      >
                        {c.title}
                      </h3>
                      <span
                        className="text-[11px] font-bold text-ct-ink-3 tabular-nums"
                        style={{ fontFamily: 'IBM Plex Mono, monospace' }}
                      >
                        0{i + 1}
                      </span>
                    </div>
                    <p className="text-sm text-ct-ink-2 leading-relaxed">{c.desc}</p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
